module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"oneOf": [
		{
			"$ref": "#basicFilter"
		},
		{
			"$ref": "#advancedFilter"
		}
	],
	"invalidMessage": "filter is invalid"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/filter.json
 ** module id = 2
 ** module chunks = 0
 **/